<template>
  <div>
    <slot name="txtBefore">
      <h2>Hier bestimmen Sie ob und wie wir Sie zur Beratung kontaktieren dürfen</h2>
    </slot>
    <div v-for="consent in editableConsents" :key="consent.consentType" :class="consent.name">
      <slot :name="`txtBeforeConsent${consent.name}`"></slot>
      <ConsentAccept :given-consent="consent" :channel-types="consent.channelTypes" @update:changedConsent="changedConsent">
        <template v-for="slot in possibleChildSlotsFor('Accept' + consent.name)" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ConsentAccept>
      <slot :name="`txtAfterConsent${consent.name}`"></slot>
    </div>

    <slot name="txtAfterConsents"></slot>

    <Stepper :show-prev="false" :loading-next="loading" :disabled-next="loading" @next="saveConsentChanges()">
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>

    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import Stepper from '../../../generic/Stepper.vue'
import processSteps from '../../../../mixins/processSteps'
import { stepName as nextStep } from '../../../generic/Success2.vue'
import ConsentAccept from './ConsentAccept.vue'
import { wrapQuery } from '../../../../helper/wrapGQLQuery'
import gql from 'graphql-tag'
import slotProxy from '../../../../mixins/slotProxy'
import { mapActions } from 'vuex'
import preFilledInput from '@/mixins/preFilledInput'
import transaction from '@/mixins/transaction'

export const stepName = 'change'

export default {
  name: 'ChangeConsentWrapper',
  components: { ConsentAccept, Stepper },
  data() {
    return {
      customerConsents: {
        consents: [],
        consentTexts: []
      },
      loading: false
    }
  },
  mixins: [
    processSteps(stepName, stepName, nextStep),
    preFilledInput('editableConsents', 'consents'),
    slotProxy(),
    transaction('consent')
  ],
  apollo: {
    customerConsents: function() {
      return wrapQuery(
        gql`
          fragment Channel on AdChannel {
            adChannelType
            changeDate
            channel
            subChannel
            userId
          }
          query consent {
            customerConsents {
              consentTexts {
                name
                text
                version
                hash
              }
              consents {
                consentType
                selectedAdChannels {
                  ...Channel
                }
                notSelectedAdChannels {
                  ...Channel
                }
              }
            }
          }
        `,
        this,
        'customerConsents',
        {},
        null,
        {
          fetchPolicy: 'cache-first'
        }
      )
    }
  },
  methods: {
    ...mapActions('consent', ['changeConsent']),
    saveConsentChanges() {
      if (this.loading) return
      this.loading = true
      this.changeConsent({ changeConsentData: this.editableConsents, nextStep: nextStep }).then(
        () => {
          this.loading = false
        },
        () => {
          this.loading = false
        }
      )
    },
    changedConsent(changed) {
      this.editableConsents = (this.editableConsents || this.consents).map(consent => {
        if (consent.consentType === changed.consentType) {
          return changed
        }
        return consent
      })
    }
  },
  computed: {
    consents: function() {
      return this.filterConsents?.map(configConsent => {
        return {
          ...configConsent,
          ...this.customerConsents.consentTexts.find(text => text.name === configConsent.name),
          ...this.customerConsents.consents.find(consent => consent.consentType === configConsent.consentType),
          selected: this.customerConsents.consents.find(consent => consent.consentType === configConsent.consentType) != null
        }
      })
    }
  },
  props: {
    filterConsents: {
      type: Array,
      default: () => [{ consentType: 'BEW', explicit: false, name: 'name' }]
    }
  }
}
</script>
